import { AlertOctagon, Clock3, Radar, RefreshCw, Siren, Wifi } from 'lucide-react';

export default function GlobalStatusBar({
  criticalCount = 0,
  activeCount = 0,
  lastUpdated,
  recalculating = false,
  focusMode = false,
  onRecalculate,
  onToggleFocus,
}) {
  const hasCritical = criticalCount > 0;

  return (
    <section className="status-bar-glass sticky top-3 z-20 rounded-[1.45rem] border border-[rgba(var(--border),0.7)] px-4 py-3 shadow-[0_20px_40px_rgba(var(--shadow),0.12)]">
      <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <div className="flex flex-wrap items-center gap-3">
          <div className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold ${hasCritical ? 'bg-[rgba(220,38,38,0.14)] text-red-700 dark:text-red-300' : 'bg-[rgba(var(--brand),0.14)] text-[rgb(var(--brand-700))]'}`}>
            {hasCritical ? <Siren className="h-3.5 w-3.5" /> : <Wifi className="h-3.5 w-3.5" />}
            {hasCritical ? 'Problemas activos' : 'Sistema estable'}
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-[rgba(var(--fg),0.04)] px-3 py-1.5 text-xs font-medium text-[rgba(var(--muted),0.96)]">
            <Radar className="h-3.5 w-3.5 text-[rgb(var(--brand))]" />
            {activeCount} alertas activas
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-[rgba(var(--fg),0.04)] px-3 py-1.5 text-xs font-medium text-[rgba(var(--muted),0.96)]">
            <AlertOctagon className="h-3.5 w-3.5 text-red-500" />
            {criticalCount} criticas
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-[rgba(var(--fg),0.04)] px-3 py-1.5 text-xs font-medium text-[rgba(var(--muted),0.96)]">
            <Clock3 className="h-3.5 w-3.5 text-[rgb(var(--brand))]" />
            {lastUpdated ? `Actualizado ${lastUpdated}` : 'Sin actualizacion'}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={onToggleFocus}
            className={`rounded-xl border px-3 py-2 text-sm font-semibold transition ${focusMode ? 'border-[rgba(var(--brand),0.55)] bg-[rgba(var(--brand),0.12)] text-[rgb(var(--brand-700))]' : 'border-[rgba(var(--border),0.8)] bg-[rgba(var(--panel),0.9)] text-[rgb(var(--fg))]'}`}
          >
            {focusMode ? 'Salir modo foco' : 'Modo foco'}
          </button>
          <button
            type="button"
            onClick={onRecalculate}
            className="inline-flex items-center gap-2 rounded-xl bg-[rgb(var(--brand))] px-3 py-2 text-sm font-semibold text-white shadow-[0_10px_24px_rgba(var(--shadow),0.14)]"
          >
            <RefreshCw className={`h-4 w-4 ${recalculating ? 'animate-spin' : ''}`} />
            Recalcular
          </button>
        </div>
      </div>
    </section>
  );
}
